<div class="title">
    <mat-card-title>Modify Calculation Results</mat-card-title>
</div>

<div class="form-row">
    <span class="form-cell"
        title="By default this value shows current date and last full hour. That is not the value of Last Updated property from DB.">Last
        Updated (UTC)</span><input class="form-cell" matInput type="datetime-local" placeholder="start date"
        [(ngModel)]="lastUpdated">
</div>
<mat-error *ngIf="error">
    Something went wrong! Please try again.
</mat-error>

<div class="dialog-footer">
    <div class="action-button">
        <button mat-raised-button color="primary" (click)="setLastUpdated()" [disabled]="!canSave">Save</button>
        <app-spinner *ngIf="showSpinner" style="position: relative; top: -6px; left: -16px;"></app-spinner>
    </div>
    <button class="action-button" mat-raised-button color="secondary" (click)="closePopup()">Cancel</button>
</div>